import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { AlertsManagementPage } from '../../components/admin/AlertsManagementPage';

export function AlertsPage() {
  return (
    <AdminLayout
      title="Alertes"
      description="Gérez les notifications et alertes système"
    >
      <AlertsManagementPage />
    </AdminLayout>
  );
}
